import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const AdminThemeContext = createContext(null);

export const AdminThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('admin_theme') || 'dark');

  useEffect(() => {
    localStorage.setItem('admin_theme', theme);
  }, [theme]);

  const value = useMemo(
    () => ({
      theme,
      isDark: theme === 'dark',
      setTheme,
      toggleTheme: () => setTheme((prev) => (prev === 'dark' ? 'light' : 'dark')),
    }),
    [theme],
  );

  return (
    <AdminThemeContext.Provider value={value}>
      <div className={theme === 'dark' ? 'dark' : ''}>{children}</div>
    </AdminThemeContext.Provider>
  );
};

export const useAdminTheme = () => {
  const context = useContext(AdminThemeContext);
  if (!context) {
    throw new Error('useAdminTheme must be used within AdminThemeProvider');
  }
  return context;
};
